/** @format */

import React, { useEffect, useMemo, useState } from 'react';
import CustomInput from './CustomInputExt';

export type CustomAmountInputProps = {
    labelText: string;
    formControlProps: any;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    valueChange?: (value: string) => void;
    preprocessDisplayValue?: (value: any) => string;
    preprocessInternalValue?: (value: any) => string;
    allowedDecimalPlaces?: number;
    allowedCharacters?: RegExp;
    value: any;
    disabled?: boolean;
    required?: boolean;
    inputProps: any;
};

export const CustomAmountInput = (props: CustomAmountInputProps): React.ReactElement => {
    const defaultPreprocessDisplayValue = (value: string): string => {
        let tmpValue = value;
        tmpValue = tmpValue.replace(/\./g, ',');
        return tmpValue;
    };

    const defaultPreprocessInternalValue = (value: string): string => {
        let tmpValue = value;
        tmpValue = tmpValue.replace(/,/g, '.');
        return tmpValue;
    };

    const tmpDisplayValue = useMemo(() => {
        return defaultPreprocessDisplayValue(props.value);
    }, [props.value]);
    const tmpInternalValue = useMemo(() => {
        return defaultPreprocessInternalValue(props.value);
    }, [props.value]);

    const [displayValue, setDisplayValue] = useState<string>(tmpDisplayValue);
    const [internalValue, setInternalValue] = useState<string>(tmpInternalValue);
    const valueChange = props.valueChange;

    useEffect(() => {
        setDisplayValue(tmpDisplayValue);
        setInternalValue(tmpInternalValue);
    }, [tmpDisplayValue, tmpInternalValue]);

    const areCharacterAllowed = (value: string): boolean => {
        let allowedCharacters = /^[0-9,.]+$/g;
        if (props.allowedCharacters) {
            allowedCharacters = props.allowedCharacters;
        }

        let testSuccessful = false;
        testSuccessful = allowedCharacters.test(value);

        if (props.allowedDecimalPlaces) {
            const decimalTest = `[,.]{1}[0-9]{${props.allowedDecimalPlaces + 1},}$`;
            const decimalRegexp = new RegExp(decimalTest);
            testSuccessful = !decimalRegexp.test(value);
        }

        let count = 0;
        count += (value.match(/,/g) || []).length || 0;
        count += (value.match(/\./g) || []).length || 0;
        if (count > 1) {
            testSuccessful = false;
        }

        return testSuccessful;
    };

    const preprocessDisplayValue = (value: string): string => {
        let tmpValue = value;
        if (props.preprocessDisplayValue) {
            tmpValue = props.preprocessDisplayValue(tmpValue);
        } else {
            tmpValue = defaultPreprocessDisplayValue(tmpValue);
        }
        return tmpValue;
    };

    const preprocessInternalValue = (value: string): string => {
        let tmpValue = value;
        if (props.preprocessInternalValue) {
            tmpValue = props.preprocessInternalValue(tmpValue);
        } else {
            tmpValue = defaultPreprocessInternalValue(tmpValue);
        }
        return tmpValue;
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (props.disabled) {
            return;
        }

        const value = e?.target?.value || '';

        if (!areCharacterAllowed(value)) {
            return;
        }

        const tmpInternalValue = preprocessInternalValue(value);
        setInternalValue(tmpInternalValue);
        setDisplayValue(preprocessDisplayValue(value));

        if (props.onChange) {
            props.onChange(e);
        }

        if (valueChange) {
            valueChange(tmpInternalValue);
        }
    };

    return (
        <CustomInput
            labelText={props.labelText}
            formControlProps={props.formControlProps}
            onChange={onChange}
            value={displayValue}
            required={props.required}
            inputProps={props.inputProps}
        />
    );
};

export default CustomAmountInput;
